module.exports = __webpack_public_path__ + "img/shop-talk-logo.93d428d6.png";